import { createMiddleware } from 'redux-beacon';
import logger from '@redux-beacon/logger';
import { chain, type, map, toPairs, fromPairs, pipe } from 'ramda';
import createGtmExtension from '@redux-beacon/google-tag-manager';

function createAnalyticsMiddleware(target, events) {
  // No tracking on server-side
  if (!process.browser) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  // No tracking in development environment
  if (process.env.NODE_ENV !== 'production') {
    return createMiddleware(events, function () {}, { logger: logger });
  }

  return createMiddleware(events, target);
}

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Source: https://github.com/ramda/ramda/wiki/Cookbook
function flattenObject(obj) {
  function go(obj_) {
    return chain(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      if (type(v) === 'Object' || type(v) === 'Array') {
        return map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              k_ = _ref4[0],
              v_ = _ref4[1];

          return [k + '.' + k_, v_];
        }, go(v));
      } else {
        return [[k, v]];
      }
    }, toPairs(obj_));
  }

  return fromPairs(go(obj));
}

/**
 * Set up analytics middleware
 * @memberof analytics/gtm
 * @param {Object} events
 * @returns {Function} Redux middleware
 */
function middleware(events) {
  return createAnalyticsMiddleware(createGtmExtension(), map(function (f) {
    return pipe(f, flattenObject);
  }, events));
}

export { flattenObject, middleware };
